export default __webpack_public_path__ + "static/media/tyre-size-guide.6fe401a2.png";